import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {}
}));

const CampaignTabBar = props => {
  const { className, staticContext, match, onTabChange, ...rest } = props;
  const history = useHistory();
  const { campaignUuid } = useParams();
  const value = history.location.pathname;
  const tabValue = campaignUuid
    ? value.slice(0, value.length - (campaignUuid.length + 1))
    : value;

  const classes = useStyles();

  const handleTabChange = (event, newValue) => {
    if (campaignUuid) {
      newValue = `${newValue}/${campaignUuid}`;
    }
    if (typeof onTabChange === 'function') {
      onTabChange(newValue);
    }
    history.push(newValue);
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <AppBar position="static">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="Campaign Workflow Steps">
          <Tab label="Details" value="/campaign/details" />
          <Tab label="Recipients" value="/campaign/recipients" />
          <Tab label="Design" value="/campaign/design" />
          <Tab label="Schedule" value="/campaign/schedule" />
        </Tabs>
      </AppBar>
    </div>
  );
};

CampaignTabBar.propTypes = {
  className: PropTypes.string
};

export default CampaignTabBar;
